import { render, staticRenderFns } from "./ViewReservations.vue?vue&type=template&id=9f122094&scoped=true&"
import script from "./ViewReservations.vue?vue&type=script&lang=js&"
export * from "./ViewReservations.vue?vue&type=script&lang=js&"
import style0 from "./ViewReservations.vue?vue&type=style&index=0&id=9f122094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f122094",
  null
  
)

export default component.exports